import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  input
} from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";
import { FilterSectionsPipe } from "../../../shared/pipes/filter.pipe";
import { FormsModule } from "@angular/forms";
import { StudentDto } from "../../interfaces/student_dto";
import { addStudent, selectStudent } from "../../ngrx/students.actions";
import { ColorService } from "src/app/shared/services/color.service";
import { StudentAddRequest } from "../../interfaces/student_add_request";
import { AvatarComponent } from "../../components/avatar/avatar.component";
import { NoSelectionComponent } from "src/app/shared/components/no-selection/no-selection.component";
import { JoyrideModule } from "ngx-joyride";

@Component({
    selector: "app-students",
    templateUrl: "students.page.html",
    styleUrls: ["students.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        IonicModule,
        FilterSectionsPipe,
        FormsModule,
        RouterModule,
        AvatarComponent,
        NoSelectionComponent,
        JoyrideModule
    ]
})
export class StudentsPage {
  @Output() openStudentDialog: EventEmitter<any> = new EventEmitter();
  @Output() studentClick: EventEmitter<any> = new EventEmitter();
  @Output() onRefresh: EventEmitter<any> = new EventEmitter();
  @Output() onArchivedStudents: EventEmitter<any> = new EventEmitter();
  @Output() reportClick: EventEmitter<any> = new EventEmitter();
  readonly isSelection = input<boolean>(false);
  readonly sections = input<{
    letter: string;
    students: StudentDto[];
}[]>(undefined);
  readonly mobile = input(true);
  presentingElement = null;

  filterTerm!: string;
  constructor(
    private store: Store,
    private colorService: ColorService,
    private modalController: ModalController
  ) {}

  ngOnInit() {
    this.presentingElement = document.getElementById("main-content");
  }

  async studentClicked(student) {
    this.studentClick.emit();

    if (await this.modalController.getTop()) {
      this.modalController.dismiss(student);
    } else {
      this.store.dispatch(selectStudent({ student }));
    }
  }

  generateReport() {
    this.reportClick.emit();
  }

  getColor(student: StudentDto) {
    return this.colorService.getColor(student.forename);
  }

  openArchivedStudents() {
    this.onArchivedStudents.emit();
  }

  doRefresh(event) {
    this.onRefresh.emit(event);
  }

  openStudentModal() {
    this.openStudentDialog.emit();
  }

  closeModal() {
    this.modalController.dismiss(null, "cancel");
  }

  saveNewStudent(event: {
    student: StudentAddRequest;
    profile_picture: string;
  }) {
    this.store.dispatch(
      addStudent({
        student: event.student,
        profile_picture: event.profile_picture,
      })
    );
    this.modalController.dismiss(null, "save");
  }

  trackByFn(section) {
    return section.students.map((s) => s?.student_id).join();
  }
}
